import { FlexRow, FlexRowProps } from '@framework/ui';
import { Space, Typography } from 'antd';
import clx from 'classnames';
import React from 'react';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import styled, { useTheme } from 'styled-components';
const { Text, Title } = Typography;

const TitleSubmissionRowWrapper = styled.div`
  padding: 16px 0;
  // fix del titolo quahdo la card contiene tabs
  .ant-card-contain-tabs & {
    padding: 0;
  }
  &.no-padding {
    padding: 0;
  }
  &.has-extra-right-element {
    // per mostrare completamente il focus di accesibilità del pulsante
    padding-right: 5px;
  }
`;
const TitleMobileSpaceWrapper = styled(Space)`
  width: 100%;
`;

const StyledTitle = styled(Title)`
  &&& {
    &.ant-typography {
      margin-bottom: 0;
      overflow: unset;
      white-space: wrap;
      text-overflow: unset;
    }
  }
`;

export interface TitleSubmissionRowProps extends FlexRowProps {
  noPadding?: boolean;
  stateTag?: React.ReactNode;

  afterTitle?: React.ReactNode;
  /** Per spostare il focus sul titolo se necessario - accessibilità */
  id?: string;
}

/**
 * Titolo della richiesta
 */
export function TitleSubmissionRow(props: TitleSubmissionRowProps) {
  const { children, noPadding, stateTag, afterTitle, id, ...rest } = props;
  const isMobile = useBreakpoint(down('md'));
  const theme = useTheme();
  const needSpace = !!props.left || !!props.right;
  const after = theme.submissionStateTagPositionAfter ? stateTag : null;
  const before = theme.submissionStateTagPositionAfter ? null : stateTag;

  return (
    <TitleSubmissionRowWrapper
      className={clx({
        'no-padding': noPadding,
        'has-extra-right-element': !!props.right,
      })}
    >
      {isMobile ? (
        <TitleMobileSpaceWrapper direction="vertical">
          {rest.left}
          {/* {needSpace && <VerticalSpace size={8} />} */}
          <FlexRow {...rest} left={undefined} right={undefined}>
            {before}
            <StyledTitle
              level={1}
              id={id ?? undefined}
              tabIndex={id ? -1 : undefined}
            >
              {children}
            </StyledTitle>
            {after}
          </FlexRow>
          {rest.right}
        </TitleMobileSpaceWrapper>
      ) : (
        <FlexRow {...rest}>
          {before}
          <StyledTitle level={1}>{children}</StyledTitle>
          {after}
        </FlexRow>
      )}
      {afterTitle}
    </TitleSubmissionRowWrapper>
  );
}
